var helper = {
  screen:
    window.location.href.indexOf("adm_processo") != -1
      ? "adm_processo"
      : window.location.href.indexOf("documento_inserir") != -1
      ? "documento_inserir"
      : window.location.href.indexOf("captura") != -1
      ? "captura"
      : window.location.href.indexOf("busca_geral") != -1
      ? "busca_geral"
      : window.location.href.indexOf("documento_busca") != -1
      ? "documento_busca"
      : "",
  isMobile: {
    Android: function() {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function() {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
      return navigator.userAgent.match(/IEMobile/i);
    },
    any: function() {
      return (
        helper.isMobile.Android() ||
        helper.isMobile.BlackBerry() ||
        helper.isMobile.iOS() ||
        helper.isMobile.Opera() ||
        helper.isMobile.Windows()
      );
    }
  },
  updateChosen: function() {
    setTimeout(function() {
      $('[data-rel="chosen"]').trigger("chosen:updated");
    }, 200);
  },
  getAttachment: function(attachment_id) {
    var attachment;
    $.each(document_consult.current_search, function(i, current_document) {
      $.each(
        (current_document.attachedForms || []).concat(
          current_document.attachments
        ),
        function(j, current_attachment) {
          if (
            current_attachment.mime
              ? current_attachment.id == attachment_id
              : current_attachment.documentId == attachment_id
          ) {
            attachment = current_attachment;
          }
        }
      );
    });
    return attachment;
  },
  getDocument: function(document_id) {
    var document = $.map(document_consult.current_search, function(
      current_document
    ) {
      if (current_document.id == document_id) return current_document;
    })[0];
    return document;
  },
  getDocumentIndexInCurrentSearch: function(document_id) {
    return $.map(document_consult.current_search, function(
      current_document,
      i
    ) {
      if (current_document.id == document_id) return i;
    })[0];
  },
  getDocuments: function(documents_id) {
    return $.map(document_consult.current_search, function(current_document) {
      if (documents_id.indexOf(current_document.id) != -1)
        return current_document;
    });
  },
  getSelectedDocuments: function() {
    var documents_id = document_consult.selection.get();
    return helper.getDocuments(documents_id);
  },
  getEstablishmentIds: function(accountId, accountType) {
    var accounts;
    if (window.location.search.indexOf("adm_processo") != -1) {
      accounts = process_management.current.accounts;
    } else {
      accounts = document_consult.current.accounts;
    }

    var establishmentIds = [];
    var i, j, company, companies, group, groups, establishments;
    switch (accountType) {
      case "F":
        company = $.map(accounts, function(account) {
          if (account.accountId == parseInt(accountId)) return account;
        })[0];

        groups = company.children;

        for (i = 0; i < groups.length; i++) {
          group = groups[i];
          establishments = group.children;
          establishmentIds = establishmentIds.concat(
            $.map(establishments, function(establishment) {
              return establishment.accountId;
            })
          );
        }
        break;
      case "G":
        group = null;

        if (accounts[0].accountType == "G") {
          groups = accounts;

          for (j = 0; j < groups.length; j++) {
            if (groups[j].accountId == accountId) {
              group = groups[j];
              break;
            }
          }
        } else {
          companies = accounts;

          group = null;

          for (i = 0; i < companies.length; i++) {
            company = companies[i];
            groups = company.children;

            for (j = 0; j < groups.length; j++) {
              if (groups[j].accountId == accountId) {
                group = groups[j];
                break;
              }
            }

            if (group != null) break;
          }
        }

        establishments = group.children;
        establishmentIds = $.map(establishments, function(establishment) {
          return establishment.accountId;
        });
        break;
    }

    return establishmentIds;
  },
  getUrlParams: function() {
    var reg = new RegExp(/[&?]+([a-zA-Z0-9_\-]+\=[a-zA-Z0-9_\-=]+)/, "g"),
      urlLocation = location.search.match(reg),
      paramsMap = new Map(),
      cleanParam = null;

    if (!urlLocation) {
      return;
    }

    urlLocation.forEach(function(param) {
      cleanParam = param.replace(/[?&]/, "");

      if (cleanParam.length) {
        var position = cleanParam.indexOf("="),
          key = cleanParam.substr(0, position),
          value = cleanParam.substr(position + 1, cleanParam.length - 1);

        paramsMap.set(key, value);
      }
    });

    return paramsMap;
  },
  getUrlParam: function(paramName) {
    var params = this.getUrlParams(),
      foundParam = null;

    if (!params) {
      return;
    }

    if (params.has(paramName)) {
      foundParam = params.get(paramName);
    }
    return foundParam;
  },
  redirectUserBasedOnResource: async ({featureId}) => {

    const ROLE_TYPE_MENU_PROCESS = 58;
    const ROLE_TYPE_DOCUMENT_APPROVAL = 52;
    const ROLE_TYPE_MENU_SIGNATURE = 63;
    const ROLE_TYPE_DOCUMENTS_CATCH = 101;
    const ROLE_TYPE_MENU_DOCUMENTS_CATCH = 34;
    const ROLE_TYPE_DOCUMENTS_VIEW = 4;
    const ROLE_TYPE_DOCUMENTS_SCREEN = 2;

    const features = await window.features();
    
    if(!features[featureId]) {
      const url = new URL(window.location.href);

      if (helper.verifyResource(ROLE_TYPE_MENU_PROCESS)) {
        const params = url.searchParams.set('go', 'adm_processo');
        window.location.href = url.href;
        return;
      }

      if (
        helper.verifyResource(ROLE_TYPE_DOCUMENT_APPROVAL) || 
        helper.verifyResource(ROLE_TYPE_MENU_SIGNATURE) ||
        helper.verifyResource(ROLE_TYPE_DOCUMENTS_VIEW) ||
        helper.verifyResource(ROLE_TYPE_DOCUMENTS_SCREEN)
      ) {
        const params = url.searchParams.set('go', 'documento_busca');
        window.location.href = url.href;
        return;
      }

      if (
        helper.verifyResource(ROLE_TYPE_DOCUMENTS_CATCH) || 
        helper.verifyResource(ROLE_TYPE_MENU_DOCUMENTS_CATCH) 
      ) {
        const params = url.searchParams.set('go', 'captura');
        window.location.href = url.href;
        return;
      }	
    }
  },
  setAllPropertiesInLocalStorage(object) {
    var keys = Object.keys(object);
    var key, value;

    for (var i = 0; i < keys.length; i++) {
      key = keys[i];
      value = object[key];

      if (value && typeof value === "object" && !Array.isArray(value)) {
        var newObject = {};

        $.each(Object.keys(value), function(i, currKey) {
          newObject[key + "." + currKey] = object[key][currKey];
        });

        helper.setAllPropertiesInLocalStorage(newObject);
      } else if (value && typeof value === "object" && Array.isArray(value)) {
        localStorage.setItem(key, JSON.stringify(value));
      } else {
        localStorage.setItem(key, value);
      }
    }
  },
  setAllPropertiesInSessionStorage(object) {
    var keys = Object.keys(object);
    var key, value;

    for (var i = 0; i < keys.length; i++) {
      key = keys[i];
      value = object[key];

      if (value && typeof value === "object" && !Array.isArray(value)) {
        var newObject = {};

        $.each(Object.keys(value), function(i, currKey) {
          newObject[key + "." + currKey] = object[key][currKey];
        });

        helper.setAllPropertiesInLocalStorage(newObject);
      } else if (value && typeof value === "object" && Array.isArray(value)) {
        sessionStorage.setItem(key, JSON.stringify(value));
      } else {
        sessionStorage.setItem(key, value);
      }
    }
  },
  validMimeTypes: function(mimeType) {
    const MIME_TYPE_IMAGE = "image/*";
    const MIME_TYPE_PDF = "application/pdf";
    const MIME_TYPE_DOC = "application/msword";
    const MIME_TYPE_DOCX =
      "	application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    const MIME_TYPE_PPT = "application/vnd.ms-powerpoint";
    const MIME_TYPE_PPTX =
      "application/vnd.openxmlformats-officedocument.presentationml.presentation";

    if (mimeType.includes("image")) {
      mimeType = "image/*";
    }

    const mimeTypes = {
      [`${MIME_TYPE_IMAGE}`]: () => true,
      [`${MIME_TYPE_PDF}`]: () => true,
      [`${MIME_TYPE_DOC}`]: () => true,
      [`${MIME_TYPE_DOCX}`]: () => true,
      [`${MIME_TYPE_PPT}`]: () => true,
      [`${MIME_TYPE_PPTX}`]: () => true,
      invalid: () => false
    };

    return (mimeTypes[mimeType] || mimeTypes.invalid)();
  },
  verifyResource: function(resourceId) {
    let resourceList;

    try {
      resourceList = JSON.parse(localStorage.resourceList);
    } catch (e) {}

    if (!resourceList || !resourceList.length) {
      return;
    }

    resourceList = resourceList.map(({ resource, hasPermission }) => {
      if (hasPermission) {
        return resource;
      }
    });

    if (resourceList.includes(resourceId)) {
      return true;
    }
    return false;
  }
};

var ui = {
  block: function() {
    $("#blockUI").fadeIn(300);
  },
  unblock: function() {
    $("#blockUI").fadeOut(300);
  }
};

var Base64 = {
  _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  encode: function(e) {
    var t = "";
    var n, r, i, s, o, u, a;
    var f = 0;
    e = Base64._utf8_encode(e);
    while (f < e.length) {
      n = e.charCodeAt(f++);
      r = e.charCodeAt(f++);
      i = e.charCodeAt(f++);
      s = n >> 2;
      o = ((n & 3) << 4) | (r >> 4);
      u = ((r & 15) << 2) | (i >> 6);
      a = i & 63;
      if (isNaN(r)) {
        u = a = 64;
      } else if (isNaN(i)) {
        a = 64;
      }
      t =
        t +
        this._keyStr.charAt(s) +
        this._keyStr.charAt(o) +
        this._keyStr.charAt(u) +
        this._keyStr.charAt(a);
    }
    return t;
  },
  decode: function(e) {
    var t = "";
    var n, r, i;
    var s, o, u, a;
    var f = 0;
    e = e.replace(/[^A-Za-z0-9+/=]/g, "");
    while (f < e.length) {
      s = this._keyStr.indexOf(e.charAt(f++));
      o = this._keyStr.indexOf(e.charAt(f++));
      u = this._keyStr.indexOf(e.charAt(f++));
      a = this._keyStr.indexOf(e.charAt(f++));
      n = (s << 2) | (o >> 4);
      r = ((o & 15) << 4) | (u >> 2);
      i = ((u & 3) << 6) | a;
      t = t + String.fromCharCode(n);
      if (u != 64) {
        t = t + String.fromCharCode(r);
      }
      if (a != 64) {
        t = t + String.fromCharCode(i);
      }
    }
    t = Base64._utf8_decode(t);
    return t;
  },
  _utf8_encode: function(e) {
    e = e.replace(/rn/g, "n");
    var t = "";
    for (var n = 0; n < e.length; n++) {
      var r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
      } else if (r > 127 && r < 2048) {
        t += String.fromCharCode((r >> 6) | 192);
        t += String.fromCharCode((r & 63) | 128);
      } else {
        t += String.fromCharCode((r >> 12) | 224);
        t += String.fromCharCode(((r >> 6) & 63) | 128);
        t += String.fromCharCode((r & 63) | 128);
      }
    }
    return t;
  },
  _utf8_decode: function(e) {
    var t = "";
    var n = 0;
    var r = (c1 = c2 = 0);
    while (n < e.length) {
      r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
        n++;
      } else if (r > 191 && r < 224) {
        c2 = e.charCodeAt(n + 1);
        t += String.fromCharCode(((r & 31) << 6) | (c2 & 63));
        n += 2;
      } else {
        c2 = e.charCodeAt(n + 1);
        c3 = e.charCodeAt(n + 2);
        t += String.fromCharCode(
          ((r & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
        );
        n += 3;
      }
    }
    return t;
  }
};
